module.exports = __webpack_public_path__ + "static/social-dashboard-brown-ac2baadd9654f6368079164c51e5d7a7.svg";